module.exports = window["emergence"];